import React, { memo, useMemo } from 'react'

import useDisabledSelector from 'Pods/ThreeDStudio/Hooks/useDisabledSelector'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import ButtonGroupSelector from 'Pods/ThreeDStudio/Shared/ButtonGroupSelector/ButtonGroupSelector'
import { setMaterial } from 'Pods/ThreeDStudio/Store/actions/textureSettings'
import { MATERIAL } from 'Pods/ThreeDStudio/Store/constants'

const handlePbrClick = () => setMaterial(MATERIAL.PBR)
const handleBasicClick = () => setMaterial(MATERIAL.BASIC)

function MaterialSelector() {
  const t = useTranslation()
  const { isFullyDisabled, disabledValues } = useDisabledSelector('material', 'enhancedModelSchema')

  const buttons = useMemo(() => [
    {
      id: MATERIAL.PBR,
      label: t('viewerSidebar.enhance.texture.material.pbr'),
      onClick: handlePbrClick,
      disabled: isFullyDisabled || disabledValues.includes(MATERIAL.PBR),
    },
    {
      id: MATERIAL.BASIC,
      label: t('viewerSidebar.enhance.texture.material.basic'),
      onClick: handleBasicClick,
      disabled: isFullyDisabled || disabledValues.includes(MATERIAL.BASIC),
    },
  ], [t, isFullyDisabled, disabledValues])

  return (
    <ButtonGroupSelector
      buttons={buttons}
      keyName="material"
      sliceName="textureSettings"
      label={t('viewerSidebar.enhance.texture.material.label')}
    />
  )
}

export default memo(MaterialSelector)
